// ----------------------------------------------------------------------

export const account = {
  displayName: 'Jooodah Dashboard',
  email: 'admin@jooodah.com',
  photoURL: 'https://www.jooodah.com/img/logo.png',
};
